<template>
    <div>
        <b-card v-show="editMode===0">
            <b-row>
                <b-col sm="12" class="text-right">
                    <b-btn-group size="sm">
                        <b-button variant="white" class="button-icon-only mr-1" title="Обновить"
                                  @click="buttonRefreshClicked"
                        >
                            <i class="fa fa-sync"/>
                        </b-button>
                        <b-button v-show="userActionAccessArray['new']" variant="success" @click="buttonAddClicked">
                            <i class="fa fa-plus"/> Новая запись
                        </b-button>
                    </b-btn-group>
                </b-col>
            </b-row>
            <MyToolbar>
                <MyToolbarItem>
                    <b-input v-model="searchQuickFilter" @keyup.prevent.enter="buttonSearchClicked" maxlength="200"
                             size="sm" placeholder="Поиск..." ref="inputQuickFilter" @keyup.esc="searchQuickFilter=''"
                    />
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-button size="sm" variant="secondary" @click="buttonSearchClicked">Поиск</b-button>
                    <b-button size="sm" :variant="sortMode===0 ? 'secondary' : 'primary'" title="Расширенный поиск"
                              class="button-icon-only-normal ml-2"
                              @click="buttonAdvSearchShowClicked"
                    >
                        <i class="fas fa-cog"/>
                    </b-button>
                </MyToolbarItem>
            </MyToolbar>

            <b-alert :show="err" :variant="errVariant" class="mb-4">{{errText}}</b-alert>

            <b-table outlined hover head-variant="light" :fields="srpuBeliverListFields"
                     :items="srpuBelieverList"
                     responsive="responsive" :no-local-sorting="true" sort-by="Believer"
                     @row-clicked="tableRowClicked"
                     @sort-changed="sortChanged"
            >
                <template #cell(IsDefault)="data">
                    <b-badge :variant="(data.item.IsDefault) ? 'primary': 'light'">
                        {{(data.item.IsDefault) ? "Да": "Нет"}}
                    </b-badge>
                </template>
            </b-table>
            <b-row>
                <b-col sm="6">
                    <b-pagination first-number last-number
                                  v-model="recordCurrentPageNumber" @input="loadSrpuBelieverList"
                                  :total-rows="recordTotalNumber" :per-page="recordCountPerPage"
                    />
                </b-col>
                <b-col sm="6">
                    <div class="custom-items-per-page-div">
                        <label>Показать записей:</label>
                        <b-form-select id="input-records-per-page" size="sm" style="margin-left: 10px;width:65px"
                                       :options="recordCountPerPageArray" v-model="recordCountPerPage"
                                       @change="loadSrpuBelieverList"
                        />
                    </div>
                </b-col>
            </b-row>

        </b-card>
        <b-card v-show="editMode===1" :title="addEditTitle">
            <b-alert :show="err" :variant="errVariant" class="mb-3">{{errText}}</b-alert>
            <b-form @submit.prevent="saveRecord" @reset.prevent="cancelRecord">
                <b-row>
                    <b-col md="12" v-if="userActionAccessCompany">
                        <b-form-group label="РЭК" label-for="select-edit-company" class="required">
                            <b-select id="select-edit-company" :options="editCompanies"
                                      v-model="editCompanyUid"
                                      ref="selectEditCompany" :disabled="recordUid.length!==0"
                            />

                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Поверитель" label-for="input-edit-believer" class="required">
                            <b-input id="input-edit-believer" v-model="editBeliever" @keyup.esc="cancelRecord"
                                     ref="inputEditBeliever" :disabled="getEditControlStatus" maxlength="50"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="По умолчанию" label-for="check-edit-is-default">
                            <b-form-checkbox switch size="lg" id="check-edit-is-default" class="mt-2"
                                             v-model="editIsDefault" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Примечание" label-for="textarea-edit-description">
                            <b-textarea id="textarea-edit-description" v-model="editDescription" rows="2"
                                        :disabled="getEditControlStatus" @keyup.esc="cancelRecord"
                                        maxlength="500"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Статус записи" label-for="input-edit-record-status"
                                      class="required">
                            <b-select id="input-edit-record-status" :options="editRecordStatuses"
                                      v-model="editRecordStatus"
                                      :disabled="!userActionAccessArray['status']"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <div class="mt-5">
                    <b-button v-show="userActionAccessArray['edit']" type="submit" variant="primary">Сохранить
                    </b-button>
                    <b-button type="reset" variant="secondary" class="ml-2">
                        {{userActionAccessArray["edit"] ? 'Отмена': 'Закрыть'}}
                    </b-button>
                </div>

            </b-form>
        </b-card>

        <b-modal ref="modal-search" hide-footer centered title="Расширенный поиск" @hidden="modalHidden">
            <b-row>
                <b-col sm="12" v-if="userActionAccessCompany">
                    <b-form-group label="РЭК" label-for="select-AdvSearch-company">
                        <b-select id="select-AdvSearch-company" :options="searchCompanies"
                                  v-model="searchCompanyUid" autofocus
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group label="Статус записи" label-for="input-AdvSearch-record-status">
                        <b-select id="input-AdvSearch-record-status" :options="searchRecordStatuses"
                                  v-model="searchRecordStatus"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-button variant="outline-danger" @click="buttonAdvSearchCancelClicked">Сбросить</b-button>
                <b-button variant="secondary" class="ml-2 float-right" @click="buttonAdvSearchCloseClicked">Закрыть
                </b-button>
                <b-button variant="primary" class="float-right" @click="buttonAdvSearchOkClicked">Поиск</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
    import MyToolbar from "@/view/components/MyToolbar";
    import MyToolbarItem from "@/view/components/MyToolbarItem";
    import axios from "axios";

    export default {
        name: "SRPUBelievers",
        components: {MyToolbar, MyToolbarItem},
        data() {
            return {
                userData: this.$store.getters.getUserData,
                recordCountPerPageArray: this.$store.getters.getRecordCountPerPageArray || [],
                recordCountPerPage: this.$store.getters.getRecordCountPerPage || 20,
                recordCurrentPageNumber: 1,
                recordTotalNumber: 0,

                userActionAccessArray: [],
                userActionAccessCompany: false,

                loadProcessing: 0,

                editMode: 0,
                addEditTitle: "",
                recordUid: "",
                recordVersion: "",

                err: false,
                errText: "",
                errVariant: "danger",

                searchQuickFilter: "",
                searchRecordStatus: -1,
                searchCompanyUid: 0,

                sortMode: 0,    //0-simple, 1-advanced
                sortBy: "Believer",
                sortDesc: false,

                searchRecordStatuses: [
                    {'value': -1, 'text': "<все>"},
                    {'value': 0, 'text': "готов"},
                    {'value': 1, 'text': "только чтение"},
                    {'value': 2, 'text': "заблокирован"},
                    {'value': 3, 'text': "на удаление"},
                    {'value': 4, 'text': "в архиве"},
                ],
                searchCompanies: [],

                srpuBelieverList: [],
                srpuBeliverListFields: [
                    {key: "RowNumber", label: "№", tdClass: "pointer"},
                    {key: "CompanyAlias", label: "РЭК", sortable: true, tdClass: "pointer"},
                    {key: "Believer", label: "Поверитель", sortable: true, tdClass: "pointer"},
                    {key: "IsDefault", label: "По умолчанию", sortable: true, tdClass: "pointer", thStyle: "width:130px"},
                    {key: "RecordStatus", label: "Статус", sortable: true, tdClass: "pointer"},
                ],

                editCompanies: [],
                editRecordStatuses: [],
                recordStatusesForAdd: [
                    {'value': 0, 'text': "готов"},
                    {'value': 1, 'text': "только чтение"},
                ],
                recordStatusesForEdit: [
                    {'value': 0, 'text': "готов"},
                    {'value': 1, 'text': "только чтение"},
                    {'value': 2, 'text': "заблокирован"},
                    {'value': 3, 'text': "на удаление"},
                    {'value': 4, 'text': "в архиве"},
                ],

                editCompanyUid: 0,
                editRecordStatus: -1,
                editBeliever: "",
                editIsDefault: false,
                editDescription: "",

                currentRecordStatus: -1,
            }
        },
        created() {
            window.addEventListener('keydown', (e) => {
                if (e.key === 'Insert' && !e.ctrlKey && !e.altKey && !e.shiftKey) {
                    this.buttonAddClicked()
                }
            });

            this.userActionAccessArray = this.getUserActionAccessArray("RefsSRPUBelievers", this.userData.UserAccess)
            this.userActionAccessCompany = this.getUserDataAccess("RefsCompanies", this.userData.UserAccess)
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Справочники", route: "srpu-believers"},
                {title: "Поверители ЦРПУ"}
            ]);

            this.loadSrpuBelieverList()
            if (this.userData.UserGroupUid === 1) this.loadCompanies()

            //If not Admin - delete Company from the list
            if (this.userData.UserGroupUid !== 1) {
                let ind = this.srpuBeliverListFields.findIndex(item => item.key.toLowerCase() === "companyalias");
                if (ind >= 0)
                    this.srpuBeliverListFields.splice(ind, 1)
            }

            //If no access to archive
            if (!this.userActionAccessArray['archive']) {
                let ind = this.searchRecordStatuses.findIndex(item => item.value === 4);
                if (ind >= 0)
                    this.searchRecordStatuses.splice(ind, 1)
            }

            this.$nextTick(() => {
                this.$refs.inputQuickFilter.$el.focus()
            })
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            loadCompanies() {
                this.editCompanies = []
                this.searchCompanies = [{'value': 0, 'text': "<все>"}]

                axios.post("/ws/ws.svc/GetRefsCompaniesArray", {
                        'Session_UID': this.userData.Session_UID,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.data.forEach(item => {
                                            this.editCompanies.push({'value': item.UID, 'text': item.Alias})
                                            this.searchCompanies.push({'value': item.UID, 'text': item.Alias})
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadSrpuBelieverList() {
                this.errTextHide()

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsSRPUBelievers", {
                        'Session_UID': this.userData.Session_UID,
                        'Page': this.recordCurrentPageNumber,
                        'RecordsPerPage': this.recordCountPerPage,
                        'SortField': this.sortBy,
                        'SortMode': (this.sortDesc ? 1 : 0),
                        'F_QuickFilter': this.searchQuickFilter,
                        'F_Company_UID': this.searchCompanyUid,
                        'F_RS': this.searchRecordStatus,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response) ||
                            this.isUndefined(resp.data.data) || this.isUndefined(resp.data.meta)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    this.srpuBelieverList = JSON.parse(resp.data.data)
                                    if (!this.isUndefined(resp.data.meta.TotalRecordsAmount)) {
                                        this.recordTotalNumber = resp.data.meta.TotalRecordsAmount
                                    } else {
                                        this.errTextShow("Ошибка при получении общего кол-ва записей.", "danger", true)
                                    }
                                } else {
                                    this.recordTotalNumber = 0
                                    this.srpuBelieverList = []

                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            sortChanged(e) {
                this.sortBy = e.sortBy
                this.sortDesc = e.sortDesc
                this.loadSrpuBelieverList()
            },
            buttonSearchClicked() {
                this.recordCurrentPageNumber = 1
                this.loadSrpuBelieverList()
            },
            buttonAdvSearchShowClicked() {
                this.$refs['modal-search'].show()
            },
            buttonAdvSearchOkClicked() {
                if (this.searchCompanyUid !== 0 || this.searchRecordStatus !== -1) {
                    this.sortMode = 1
                    this.searchQuickFilter = ""
                } else {
                    this.sortMode = 0
                }

                this.recordCurrentPageNumber = 1
                this.loadSrpuBelieverList()
                this.$refs['modal-search'].hide()
            },
            buttonAdvSearchCancelClicked() {
                this.sortMode = 0
                this.searchCompanyUid = 0
                this.searchRecordStatus = -1
                this.recordCurrentPageNumber = 1
                this.$refs['modal-search'].hide()
                this.loadSrpuBelieverList()
            },
            buttonAdvSearchCloseClicked() {
                this.$refs['modal-search'].hide()
            },

            buttonRefreshClicked() {
                this.loadSrpuBelieverList()
            },
            buttonAddClicked() {
                this.errTextHide()
                this.recordUid = ""
                this.recordVersion = ""
                this.addEditTitle = "Добавление записи"
                this.editCompanyUid = 0
                this.editBeliever = ""
                this.editIsDefault = false
                this.editDescription = ""
                this.editRecordStatus = 0
                this.currentRecordStatus = 0
                this.editRecordStatuses = this.recordStatusesForAdd

                this.editMode = 1

                if (this.userActionAccessCompany) {
                    this.$nextTick(() => {
                        if (!this.isUndefined(this.$refs.selectEditCompany))
                            this.$refs.selectEditCompany.$el.focus()
                    })
                } else {
                    this.$nextTick(() => {
                        if (!this.isUndefined(this.$refs.inputEditBeliever))
                            this.$refs.inputEditBeliever.$el.focus()
                    })
                }
            },
            tableRowClicked(item) {
                this.errTextHide()
                this.recordUid = item.UID
                this.recordVersion = ""
                this.addEditTitle = ""
                this.editCompanyUid = 0
                this.editBeliever = ""
                this.editIsDefault = false
                this.editDescription = ""
                this.editRecordStatus = -1
                this.currentRecordStatus = -1

                this.editRecordStatuses = this.recordStatusesForEdit

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsSRPUBeliever", {
                        'Session_UID': this.userData.Session_UID,
                        'F_UID': this.recordUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    let result = (JSON.parse(resp.data.data))

                                    this.editCompanyUid = result.Company_UID ? parseInt(result.Company_UID.toString()) : 0
                                    this.editBeliever = result.Believer.toString()
                                    this.editIsDefault = result.IsDefault
                                    this.editDescription = result.Description.toString()
                                    this.editRecordStatus = parseInt(result.RS.toString())
                                    this.recordVersion = result.RVV.toString()

                                    this.currentRecordStatus = this.editRecordStatus

                                    if (this.userActionAccessArray["edit"])
                                        this.addEditTitle = "Изменение записи: " + this.editBeliever
                                    else
                                        this.addEditTitle = "Просмотр записи: " + this.editBeliever
                                } else {
                                    this.errTextShow("Запись не найдена. Пожалуйста, обновите страницу.", "danger", true)
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }

                        this.editMode = 1
                        this.loadProcessing--
                        this.$nextTick(() => {
                            this.$refs.inputEditBeliever.$el.focus()
                        })
                    })
                    .catch(err => {
                        this.editMode = 1
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            saveRecord() {
                this.errTextHide()

                if (this.userData.UserGroupUid === 1 && this.editCompanyUid === "") {
                    this.errTextShow("Выберите РЭК.", "info", true)
                    return
                }
                if (this.editBeliever.toString().trim() === "") {
                    this.errTextShow("Введите поверителя.", "info", true)
                    return
                }
                if (this.editRecordStatus === -1) {
                    this.errTextShow("Выберите статус записи.", "info", true)
                    return
                }

                this.loadProcessing++
                axios.post("/ws/ws.svc/UpdateRefsSRPUBeliever", {
                        'Session_UID': this.userData.Session_UID,
                        'R_UID': this.recordUid,
                        'R_Company_UID': this.editCompanyUid,
                        'R_Believer': this.editBeliever,
                        'R_IsDefault': (this.editIsDefault ? 1 : 0),
                        'R_Description': this.editDescription,
                        'R_RS': this.editRecordStatus,
                        'R_RV': this.recordVersion,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                this.loadSrpuBelieverList()
                                this.editMode = 0
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
                this.loadProcessing--
            },
            cancelRecord() {
                this.errTextHide()
                this.editMode = 0
            },
            modalHidden() {
                this.$nextTick(() => {
                    this.$refs.inputQuickFilter.$el.focus()
                })
            }
        },
        computed: {
            getEditControlStatus: function () {
                return (!this.userActionAccessArray["edit"] || this.currentRecordStatus > 0)
            },
        },
        watch: {
            loadProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
        }
    }
</script>

<style scoped>

</style>